import COLOR from "../../constants/colors";

const styles = {
  whiteBackground: {
    background: COLOR.white,
    padding: 16,
    marginBottom: 64,
  },
  icon: {
    marginLeft: 16,
    fontSize: 24,
  },
  item: {
    marginBottom: 16,
  },
  marginLeft: {
    marginLeft: 100,
  },
  header: {
    fontSize: 28,
    fontWeight: 700,
    marginLeft: 8,
  },
  lineinfo: {
    marginTop: 15,
  },
  backgroundheader: {
    background: "white",
    // width: 350,
    // minHeight: 300,
    marginTop: 24,
    padding: 8,
  },
  editBtn: {
    width: "30%",
    marginBottom: 16,
  },
};

export default styles;
